import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTE_UPLOAD_PIC } from "../../constants/routes";

const Welcome = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col pt-4 w-full bg-red-400 rounded-full max-sm:rounded-none"
      style={{
        backgroundColor: "#FF8960",
        overflowY: "hidden",
        height: "100vh",
      }}
    >
      <div className="flex flex-col px-4 w-full">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/1126f612746ea514e349332d6fdd8ee9647d4fa70412460e368a6a5af3faf3f2?apiKey=80f439f9d23243918de9eba558cc207a&"
          alt="logo"
          style={{
            width: "83px",
            height: "44px",
            marginLeft: "-5px",
            marginBottom: "20px",
          }}
        />
        <Typography
          variant="h1"
          className="self-start mt-9 ml-2.5 text-4xl font-semibold leading-[50.05px]"
          style={{
            color: "#ffffff",
            fontFamily: "Poppins",
            fontSize: "35px",
            marginBottom: "30px",
          }}
        >
          Hi, I&apos;m Nina!
        </Typography>
        <Typography
          variant="body1"
          className="mt-8 mr-5 ml-2.5"
          style={{ color: "#ffffff", fontFamily: "DM Sans", fontSize: "16px" }}
        >
          Lovely meeting you.
          <br />
          We would like to know more about you and your preferences.
          <br />
          <br />
          It will guide us in finding your dream job.
        </Typography>
        <Button
          onClick={() => navigate(ROUTE_UPLOAD_PIC)}
          variant="contained"
          color="primary"
          className="justify-center items-center px-16 py-6 mt-7 font-medium shadow-sm rounded-[95px]"
          style={{
            borderRadius: "95px",
            backgroundColor: "#fff",
            color: "#756DE9",
            border: "1px solid #000",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            alignItems: "center",
            alignSelf: "stretch",
            padding: "15px 64px",
            marginTop: "40px",
            fontSize: "16px",
            textDecoration: "None",
            width: "100%",
            zIndex: 1,
          }}
        >
          Let&apos;s Start
        </Button>
      </div>

      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/64300db3216abced4e1984c5c1c2bc0ad47b888f515ccd3cff5568b289cec3d9?apiKey=80f439f9d23243918de9eba558cc207a&"
        alt=""
        className="mt-10 w-full aspect-[1.18]"
        style={{ position: "fixed", bottom: "0", left: "0" }}
      />
    </div>
  );
};

export default Welcome;
